'use client'

import { useEffect, useState } from 'react'
import type { IAuthUser, IProfileUser, Roles } from '../../interfaces/src'

export const useSession = () => {
  const [isInit, setIsInit] = useState(false)
  const [authUser, setAuthUser] = useState<IAuthUser | null>(null)
  const [token, setToken] = useState<string | null>(null)
  const [profile, setProfile] = useState<IProfileUser | null>(null)
  const [roles, setRoles] = useState<Roles | null>(null)

  const init = async () => {
    const {
      getCookieAuthUser,
      getCookieProfileUser,
      getCookieAuthorizationRoles,
      getCookieAuthorizationToken
    } = await import('../services')

    setAuthUser(getCookieAuthUser())
    setProfile(getCookieProfileUser())
    setRoles(getCookieAuthorizationRoles())
    setToken(getCookieAuthorizationToken())
    setIsInit(true)
  }

  useEffect(() => {
    init()
  }, [])

  const updateAuthUser = (newAuthUser: IAuthUser) => {
    setAuthUser(newAuthUser)
  }

  const updateProfile = (newProfile: IProfileUser) => {
    setProfile(newProfile)
  }

  const updateRoles = (newRoles: Roles) => {
    setRoles(newRoles)
  }

  const updateSession = () => {
    init()
  }

  return {
    isInit,
    authUser,
    profile,
    roles,
    token,
    updateAuthUser,
    updateProfile,
    updateRoles,
    updateSession
  }
}

export default useSession
